import { Injectable } from '@angular/core';
import { AuthService } from './auth-service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService { 

  constructor(private authService:AuthService,) { }
  // Main page permission 0 == all
  get isMainDashboardShow(): boolean {
    return this.authService.canAccess([1, 0]);
  }
  get isMainUserAndRoleShow(): boolean {
    return this.authService.canAccess([0,3,5]);
  }
  get isMainEventsShow(): boolean {
    return this.authService.canAccess([0,6,7,9]);
  }
  get isRoleView(): boolean {
    return this.authService.canAccess([0,3]);
  }
  get isRoleAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0, 2]);
  }
 
  get isUserView(): boolean {
    return this.authService.canAccess([0, 5]);
  }
  get isUserAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0, 4]);
  }
  
  get isEventView(): boolean {
    return this.authService.canAccess([0, 7]);
  }
  get isEventAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,6]);
  }
  
  get isEmailConfigView(): boolean {
    return this.authService.canAccess([0, 9]);
  }
  get isEmailConfigAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,8]);
  }
  
  get isGeneralSettingView(): boolean {
    return this.authService.canAccess([0, 10]);
  }
  get isLayoutColorView(): boolean {
    return this.authService.canAccess([0, 11]);
  }
  get isChangeImageView(): boolean {
    return this.authService.canAccess([0,12]);
  }
  get isEventInfoView(): boolean {
    return this.authService.canAccess([0,13]);
  }
  get isCampaignModuleView(): boolean {
    return this.authService.canAccess([0,14]);
  }
  get isRegistrationModuleView(): boolean {
    return this.authService.canAccess([0,15]);
  }
  get isPaperModuleView(): boolean {
    return this.authService.canAccess([0,16]);
  }
  get isBadgeModuleView(): boolean {
    return this.authService.canAccess([0,17]);
  }
  get isMobileModuleView(): boolean {
    return this.authService.canAccess([0,18]);
  }
  get isProgramsModuleView(): boolean {
    return this.authService.canAccess([0,19]);
  }
  get isBudgetModuleView(): boolean {
    return this.authService.canAccess([0,20]);
  }
  get isWebsiteModuleView(): boolean {
    return this.authService.canAccess([0,21]);
  }
 
  // Registration permission
  get isCurrencyView(): boolean {
    return this.authService.canAccess([0, 22]);
  }
  get isCurrencyUpdate(): boolean {
    return this.authService.canAccess([0,23]);
  }
  get isGatewayAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,24]);
  }
  
  get isGatewayView(): boolean {
    return this.authService.canAccess([0, 25]);
  }
  get isSignupFieldsView(): boolean {
    return this.authService.canAccess([0, 26]);
  }
  get isSignupFieldsAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0, 27]);
  }

  get isTaxView(): boolean {
    return this.authService.canAccess([0,29]);
  }
  get isTaxAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,30]);
  }
 
  get isAllFormsStepsView(): boolean {
    return this.authService.canAccess([0,31]);
  }
  get isAllFormsStepsAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,32]);
  }
 
  get isAllProfileView(): boolean {
    return this.authService.canAccess([0, 33]);
  }
  get isAllProfileAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,34]);
  }
  
  get isAllProfileSendEmailView(): boolean {
    return this.authService.canAccess([0,35]);
  }
  get isAllProfilePasswordResetView(): boolean {
    return this.authService.canAccess([0,36]);
  }
  get isRegAllTemplatesAndEmailView(): boolean {
    return this.authService.canAccess([0,37]);
  }
  get isRegAllTemplatesView(): boolean {
    return this.authService.canAccess([0, 38]);
  }
  get isRegAllTemplatesAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,39]);
  }
  
  get isRegScheduleTaskView(): boolean {
    return this.authService.canAccess([0,40]);
  }
  get isRegScheduleTaskAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,41]);
  }
  
  get isRegFormsAndPriceView(): boolean {
    return this.authService.canAccess([0, 42]);
  }
  get isRegDependentFieldView(): boolean {
    return this.authService.canAccess([0,43]);
  }
  get isRegDependentFieldAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0, 44]);
  }
  get isCategoryView(): boolean {
    return this.authService.canAccess([0,45]);
  }
  get isCategoryAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,46]);
  }
  get isDatewiseLabelView(): boolean {
    return this.authService.canAccess([0, 47]);
  }
  get isDatewiseLabelAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,48]);
  }
  
  get isCategoryPriceAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,49]);
  }
  
  get isExtraPersonView(): boolean {
    return this.authService.canAccess([0,50]);
  }
  get isExtraPersonAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,51]);
  }
  get isExtraPersonPriceView(): boolean {
    return this.authService.canAccess([0,52]);
  }
  get isExtraPersonPriceAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,53]);
  }
 
  get isTicketView(): boolean {
    return this.authService.canAccess([0,54]);
  }
  get isTicketAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,55]);
  }
 
  get isTicketPriceView(): boolean {
    return this.authService.canAccess([0,56]);
  }
  get isTicketPriceAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,57]);
  }
  
  get isHotelsView(): boolean {
    return this.authService.canAccess([0,58]);
  }
  get isHotelsAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,59]);
  }
  
  get isHotelsPriceView(): boolean {
    return this.authService.canAccess([0,60]);
  }
  get isHotelsPriceAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,61]);
  }
  
  get isPaymentsView(): boolean {
    return this.authService.canAccess([0,62]);
  }
  get isPaymentsAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,63]);
  }
  
  get isCouponCodeView(): boolean {
    return this.authService.canAccess([0,64]);
  }
 
  get isCouponCodeAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,65]);
  }
 
  get isReportView(): boolean {
    return this.authService.canAccess([0,66]);
  }
  get isAllDelegateView(): boolean {
    return this.authService.canAccess([0,67]);
  }
  get isTransactionView(): boolean {
    return this.authService.canAccess([0,68]);
  }
  get isTransactionAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,69]);
  }
  
  get isSendEmailView(): boolean {
    return this.authService.canAccess([0,70]);
  }
  get isDelegateChangePasswordView(): boolean {
    return this.authService.canAccess([0,71]);
  }
  get isDelegateRegDelete(): boolean {
    return this.authService.canAccess([0,72]);
  }
  get isSuccessPaymentView(): boolean {
    return this.authService.canAccess([0,73]);
  }
  get isFailedPaymentView(): boolean {
    return this.authService.canAccess([0,74]);
  }
  get isDeletedRegistrationView(): boolean {
    return this.authService.canAccess([0,75]);
  }
  get isDeletedRegistrationRestore(): boolean {
    return this.authService.canAccess([0,76]);
  }
  get isExportReportsView(): boolean {
    return this.authService.canAccess([0,77]);
  }
  get isExportReportsAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,78]);
  }
  get isExportReportsDownload(): boolean {
    return this.authService.canAccess([0,79]);
  }
  
  // Paper permission
 
  get isPaperSettingsView(): boolean {
    return this.authService.canAccess([0,80]);
  }
  get isPaperSettingsUpdate(): boolean {
    return this.authService.canAccess([0,81]);
  }
  get isPaperGuidelineView(): boolean {
    return this.authService.canAccess([0,82]);
  }
  get isPaperGuidelineUpdate(): boolean {
    return this.authService.canAccess([0,83]);
  }
  get isPaperFieldsView(): boolean {
    return this.authService.canAccess([0,84]);
  }
  get isPaperFieldsAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,85]);
  }
 
  get isPaperAllProfileView(): boolean {
    return this.authService.canAccess([0,86]);
  }
  get isPaperSendEmailView(): boolean {
    return this.authService.canAccess([0,87]);
  }
  get isPaperProfilePasswordResetView(): boolean {
    return this.authService.canAccess([0,88]);
  }
  get isPaperTemplateAndEmailView(): boolean {
    return this.authService.canAccess([0,89]);
  }
  get isPaperAllTemplateView(): boolean {
    return this.authService.canAccess([0,90]);
  }
  get isPaperAllTemplateAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,91]);
  }
  
  get isPaperScheduleTaskView(): boolean {
    return this.authService.canAccess([0,92]);
  }
  get isPaperScheduleTaskAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,93]);
  }
  get isPaperReviewerView(): boolean {
    return this.authService.canAccess([0,94]);
  }
  get isPaperReviewerAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,95]);
  }
  
  get isPaperReviewQuestionView(): boolean {
    return this.authService.canAccess([0,96]);
  }
  get isPaperReviewQuestionAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,97]);
  }
  
  get isReviewerCompareView(): boolean {
    return this.authService.canAccess([0,98]);
  }
  get isSubmittedPaperView(): boolean {
    return this.authService.canAccess([0,99]);
  }
  get isPaperAutoAssignView(): boolean {
    return this.authService.canAccess([0,100]);
  }
  get isPaperManualAssignView(): boolean {
    return this.authService.canAccess([0,101]);
  }
  get isPaperReviewerCommentsView(): boolean {
    return this.authService.canAccess([0,102]);
  }
  get isPaperAssignToReviewerView(): boolean {
    return this.authService.canAccess([0,103]);
  }
  get isSubmittedPaperDelete(): boolean {
    return this.authService.canAccess([0,104]);
  }
  get isAcceptedPaperView(): boolean {
    return this.authService.canAccess([0,105]);
  }
  get isRejectedPaperView(): boolean {
    return this.authService.canAccess([0,106]);
  }
  get isAbstractBookView(): boolean {
    return this.authService.canAccess([0,107]);
  }
  get isAbstractBookCreate(): boolean {
    return this.authService.canAccess([0,108]);
  }
  get isAbstractBookDownload(): boolean {
    return this.authService.canAccess([0,109]);
  }
  get isPaperExcelReportView(): boolean {
    return this.authService.canAccess([0,110]);
  }
  get isPaperExcelReportAddEditDeleteHide(): boolean {
    return this.authService.canAccess([0,111]);
  }
  
  get isPaperExcelReportDownload(): boolean {
    return this.authService.canAccess([0,112]);
  }
}
